"use client";

import React from "react";
import { Modal as ModalComponent, Button, Placeholder } from "rsuite";
import cx from "classnames";
import styles from "./Modal.module.scss";
import { Theme } from "@constants/enums";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    onOpen: () => void;
    backdrop: "static" | boolean;
    children?: React.ReactNode;
    modalTitle: string;
    loginClassName?: string;
    theme?: Theme;
}

const Modal: React.FC<ModalProps> = ({
    open,
    onClose,
    onOpen,
    backdrop,
    children,
    modalTitle,
    loginClassName,
    theme = Theme.LIGHT,
}) => {
    return (
        <div>
            {modalTitle && (
                <Button onClick={onOpen} className={cx(loginClassName)}>
                    {modalTitle}
                </Button>
            )}

            <ModalComponent
                backdrop={backdrop}
                keyboard={false}
                open={open}
                onClose={onClose}
                size="xs"
                className={styles["rs-modal-content"]}
                as="div"
            >
                <div className={styles.customModal} data-theme={theme}>
                    <ModalComponent.Header>
                        <ModalComponent.Title>&nbsp;</ModalComponent.Title>
                    </ModalComponent.Header>

                    <ModalComponent.Body>
                        {children || <Placeholder.Paragraph />}
                    </ModalComponent.Body>
                </div>
            </ModalComponent>
        </div>
    );
};

export default React.memo(Modal);
